import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IntubationService } from '../../intubation/services/intubation.service'
import * as actions from '../store/options.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { getServiceIdSelector } from '../../user/selectors'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { sanitizeOptionIds } from '../../../utilities/sanitize.util'

export function* setMethodOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const intubationService = new IntubationService(serviceId)
  try {
    const response: IOptionsResponse = yield call([intubationService, intubationService.getMethodOptions])
    const { entity } = response
    yield put(actions.setMethodOptions(sanitizeOptionIds(entity)))
  } catch (e) {
    yield put(throwPcrException(`setMethodOptions() error: ${e}`))
  }
}
export function* setMethodOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setMethodOptions)
}
